/** Cart attribute Shopify copies onto the order as an additional detail. */
export const TERMS_ACCEPTED_ATTRIBUTE = "terms_accepted";

/**
 * Merge the terms acceptance onto the cart's existing attributes.
 * Sending the full set keeps other attributes if Shopify replaces the hash.
 * Returns null when the customer has not accepted, so checkout does not write it.
 */
export function withTermsAcceptedAttribute(attributes, accepted) {
  if (!accepted) return null;
  const current =
    attributes && typeof attributes === "object" && !Array.isArray(attributes)
      ? attributes
      : {};
  const next = {};
  for (const [key, value] of Object.entries(current)) {
    if (value == null || key === "") continue;
    next[String(key)] = String(value);
  }
  next[TERMS_ACCEPTED_ATTRIBUTE] = "yes";
  return next;
}
